export const ADS_COUNTDOWN_ELEMENT_KIND = "ads.countdown" as const;
